import PropTypes from 'prop-types'
import React from 'react'

import Icon from '@/checkout-instore-legacy/components/Commons/Icons'
import { withMediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'

const ACTIVE_MARK_SIZE = 11

function ToolbarOption({
  icon,
  iconType,
  isEmpty = true,
  mediaQuery,
  children,
  ...rest
}) {
  const style =
    'pointer pa0 f6 f5-ns lh-title lh-copy-l bn bg-transparent c-on-base hover-mid-gray inline-flex items-center '

  const iconSize = mediaQuery({
    phone: 12,
    tablet: 12,
    desktop: 16,
  })

  const iconElm = icon ? (
    typeof icon === 'string' ? (
      <i className={`fa mr2 ${icon}`} />
    ) : (
      <span className={`dib f0 mr2`}>{icon}</span>
    )
  ) : (
    <div className="fa mr2">
      <Icon type={iconType} color="currentColor" size={iconSize} />
    </div>
  )

  return (
    <button className={style} {...rest}>
      {!isEmpty && (
        <div
          className="bg-action-primary relative dib ba b--white br-pill "
          style={{
            width: ACTIVE_MARK_SIZE,
            height: ACTIVE_MARK_SIZE,
            marginLeft: -ACTIVE_MARK_SIZE,
            top: -6,
            left: '$space-4',
          }}
        />
      )}
      {iconElm}
      <span className="t-mini t-small-ns nowrap">{children}</span>
    </button>
  )
}

ToolbarOption.propTypes = {
  isEmpty: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  iconType: PropTypes.string,
  children: PropTypes.node,
  mediaQuery: PropTypes.func.isRequired,
}

export default withMediaQuery(ToolbarOption)
